import type { LpQuery, OrderBy, WhereFilter } from 'types/common';

export default class Query {
	constructor(
		whereFilter: Array<WhereFilter> = [],
		orderBy: OrderBy = null,
		pageIndex: number = 0,
		pageSize: number = 100
	) {
		this.whereFilter = whereFilter;
		this.orderBy = orderBy;
		this.pageSize = pageSize;
		this.pageIndex = pageIndex;
	}
	whereFilter: Array<WhereFilter>;
	orderBy: OrderBy;
	pageIndex: number;
	pageSize: number;

	toLpQuery = (): LpQuery => {
		let q = Object.assign({ whereFilter: [], orderBy: null, pageIndex: 0, pageSize: 100 }, this);
		let lpQuery = {};
		if (q.whereFilter.length > 0) {
			lpQuery.where = {
				and: q.whereFilter.map(el => {
					return { [el.field]: el.value };
				})
			};
		}
		if (q.orderBy) {
			lpQuery.order = `${this.orderBy.field} ${this.orderBy.asc ? 'ASC' : 'DESC'}`;
		}
		lpQuery.skip = q.pageIndex * q.pageSize;
		lpQuery.limit = q.pageSize;

		return lpQuery;
	};

	toToLpQueryUrl = (): string => {
		let query = this.toLpQuery();
		return Object.keys(query).length > 0 ? `?filter=${JSON.stringify(query)}` : '';
	};
}



// WEBPACK FOOTER //
// ./src/utilities/Query.js